module.exports = __webpack_public_path__ + "static/media/zoek-je-een-stage-nieuw.2a938545.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Educatie/02_Voor-studenten/hq/zoek-je-een-stage-nieuw.jpg
// module id = 760
// module chunks = 0